var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import AkSpinner from "@atlaskit/spinner";
import { Grid, GridColumn } from "@atlaskit/page";
import { useRecommendedFaults } from "./useRecommendedFaults";
import { RecommendedFaultCard } from "./RecommendedFaultCard";
import { useSupportedEnvironments, usePollingQuery, useServiceId } from "../../../hooks";
import { WargamesInProgressQuery } from "../../../graphql";
import SectionMessage from "@atlaskit/section-message";
export var RecommendedFaults = function () {
    var _a = useRecommendedFaults(), isLoadingRecommendedFaults = _a.isLoading, recommendedFaults = _a.recommendedFaults;
    var _b = useSupportedEnvironments(), isLoadingSupportedEnvironments = _b.isLoading, supportedEnvironments = _b.supportedEnvironments;
    var isLoading = isLoadingRecommendedFaults || isLoadingSupportedEnvironments;
    var isEmptyStateVisible = !isLoading && recommendedFaults.length === 0;
    var isNormalStateVisible = !isLoading && recommendedFaults.length > 0;
    var serviceId = useServiceId();
    var data = usePollingQuery(WargamesInProgressQuery, {
        variables: { serviceId: serviceId }
    }, true).data;
    var isWargameInProgress = (data === null || data === void 0 ? void 0 : data.warGamesInProgressForService) !== null;
    return (React.createElement("div", null,
        React.createElement("h4", null, "Instant Wargames"),
        React.createElement("br", null),
        isLoading && (React.createElement("div", null,
            React.createElement(AkSpinner, { size: "small" }),
            React.createElement("span", null, "\u00A0\u00A0\u00A0Loading..."))),
        isEmptyStateVisible && (React.createElement("div", null, "No fault recommendations available at this time")),
        isNormalStateVisible && (React.createElement("div", null,
            isWargameInProgress && (React.createElement(SectionMessage, { appearance: "info" }, "A Wargame is already in progress")),
            React.createElement("br", null),
            React.createElement(Grid, null, recommendedFaults.map(function (recommendedFault) { return (React.createElement(GridColumn, { key: recommendedFault.id, medium: 4 },
                React.createElement(RecommendedFaultCard, __assign({}, recommendedFault, { supportedEnvironments: supportedEnvironments, isWargameInProgress: isWargameInProgress })))); })))),
        React.createElement("br", null)));
};
